<template>
  <!-- Banner inferior para UPCOMING_MAINTENANCE -->
  <v-slide-y-reverse-transition>
    <div v-if="isUpcoming || isMaintenance" class="maintenance-upcoming-banner">
      <v-icon class="mr-2" color="white" size="24">mdi-wrench-clock</v-icon>
      <span class="banner-message">{{ message }}</span>
      <v-chip color="white" variant="flat" size="large" class="ml-4 countdown-chip">
        <v-icon start size="20" color="orange-darken-3">mdi-timer-sand</v-icon>
        <span class="maintenance-end-text">{{ countdown }}</span>
      </v-chip>
    </div>
  </v-slide-y-reverse-transition>

  <!-- Banner inferior para MAINTENANCE (en pantalla de login se muestra solo el banner, sin bloquear) -->
  <v-slide-y-reverse-transition>
    <div v-if="isMaintenance" class="maintenance-active-banner">
      <v-icon class="mr-2" color="white" size="24">mdi-wrench-cog</v-icon>
      <span class="banner-message">{{ message || 'Sistema en mantenimiento' }}</span>
      <v-chip v-if="maintenanceEndDate" color="white" variant="flat" size="large" class="ml-4">
        <v-icon start size="20" color="red-darken-3">mdi-clock-outline</v-icon>
        <span class="maintenance-end-text">{{ formattedEndDate }}</span>
      </v-chip>
    </div>
  </v-slide-y-reverse-transition>

  <!-- Overlay de mantenimiento activo - solo bloquea si NO está en pantalla de login -->
<!--  <v-overlay-->
<!--    v-model="showOverlay"-->
<!--    persistent-->
<!--    no-click-animation-->
<!--    class="maintenance-overlay"-->
<!--    :z-index="9999"-->
<!--    scrim="black"-->
<!--  >-->
<!--    <div class="maintenance-screen d-flex flex-column align-center justify-center text-center">-->
<!--      <v-icon size="100" color="warning" class="mb-6 maintenance-icon">mdi-wrench-cog</v-icon>-->
<!--      <h1 class="text-h3 font-weight-bold text-white mb-4">Sistema en Mantenimiento</h1>-->
<!--      <p class="text-h6 text-grey-lighten-1 mb-6" style="max-width: 600px;">-->
<!--        {{ message }}-->
<!--      </p>-->
<!--      <v-card v-if="maintenanceEndDate" variant="outlined" color="warning" class="pa-4 mt-2" rounded="lg">-->
<!--        <div class="d-flex align-center">-->
<!--          <v-icon color="warning" class="mr-3" size="28">mdi-clock-outline</v-icon>-->
<!--          <div class="text-left">-->
<!--            <div class="text-caption text-grey-lighten-1">Fin estimado del mantenimiento</div>-->
<!--            <div class="text-h6 text-warning font-weight-bold">{{ formattedEndDate }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </v-card>-->
<!--      <v-btn-->
<!--        class="mt-8"-->
<!--        color="warning"-->
<!--        variant="outlined"-->
<!--        size="large"-->
<!--        @click="fetchStatus"-->
<!--        :loading="isLoading"-->
<!--        prepend-icon="mdi-refresh"-->
<!--      >-->
<!--        Verificar estado-->
<!--      </v-btn>-->
<!--    </div>-->
<!--  </v-overlay>-->
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useMaintenanceStatus } from '@/composables/useMaintenanceStatus'

const route = useRoute()

const {
  isUpcoming,
  isMaintenance,
  message,
  maintenanceEndDate,
  countdown,
  isLoading,
  fetchStatus,
} = useMaintenanceStatus()

const isOnAuthRoute = computed(() => route.path.startsWith('/auth'))

// El overlay solo se muestra si está en mantenimiento y NO está en la pantalla de login
const showOverlay = computed(() => isMaintenance.value && !isOnAuthRoute.value)

const formattedEndDate = computed(() => {
  if (!maintenanceEndDate.value) return ''
  const date = new Date(maintenanceEndDate.value)
  return date.toLocaleString('es-AR', {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
})
</script>

<style scoped>
.maintenance-upcoming-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background: linear-gradient(135deg, #e65100, #ff8f00);
  color: white;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.5px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.3);
  animation: pulse-bg 3s ease-in-out infinite;
}

.maintenance-active-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  background: linear-gradient(135deg, #b71c1c, #d32f2f);
  color: white;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.5px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.3);
  animation: pulse-bg 3s ease-in-out infinite;
}

.maintenance-end-text {
  color: #eedddd;
  font-weight: 700;
}

@keyframes pulse-bg {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.92; }
}

.banner-message {
  max-width: 600px;
  text-align: center;
}

.countdown-chip {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 2px;
}

.countdown-text {
  color: #e65100;
  font-family: 'Courier New', monospace;
}

.maintenance-overlay {
  backdrop-filter: blur(6px);
}

.maintenance-screen {
  padding: 40px;
}

.maintenance-icon {
  animation: rotate-gear 4s linear infinite;
}

@keyframes rotate-gear {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
